/**
 * SidebarRightCollapsedIcon - Icon für die eingeklappte rechte Sidebar
 *
 * Zeigt ein Panel-Layout mit einer vertikalen Trennlinie auf der rechten Seite (ohne Linien).
 * Wird angezeigt wenn die rechte Sidebar eingeklappt ist.
 *
 * @example
 * ```tsx
 * <SidebarRightCollapsedIcon />
 * <SidebarRightCollapsedIcon size={20} />
 * ```
 */
export const SidebarRightCollapsedIcon = ({ size = 16 }: { size?: number }) => {
  const aspectRatio = 15 / 17
  const height = Math.round(size * aspectRatio)

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1 0.6H2.1C1.27 0.6 0.6 1.27 0.6 2.1V12.1C0.6 12.93 1.27 13.6 2.1 13.6H14.1C14.93 13.6 15.6 12.93 15.6 12.1V2.1C15.6 1.27 14.93 0.6 14.1 0.6Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6 0.6V13.6"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
